import axios from 'axios'
import router from '../../router'

export default () => {
  let token = JSON.parse(localStorage.getItem('token'))
  let headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }

  // Refresh token
  let timestamp = new Date()
  let expiry = localStorage.getItem('tokenExpiry')
  let refreshExpiry = localStorage.getItem('tokenRefreshExpiry')
  let canBeRefreshed = (refreshExpiry > timestamp.getTime())

  if (expiry && token && expiry < timestamp.getTime() && canBeRefreshed) {
    axios.create({
      baseURL: process.env.HATS_API,
      withCredentials: false,
      headers
    })
      .post('authentication/refresh', { token: token })
      .then((response) => {
        const expires = response.data.data.expires - 240
        let timestamp = new Date()
        timestamp.setSeconds(timestamp.getSeconds() + expires)
        localStorage.setItem('tokenExpiry', timestamp.getTime() + '')
      })
      .catch(err => console.log(err))
  }

  if (token) {
    headers['auth-token'] = token
  }

  let clearToken = () => {
    if (localStorage.getItem('token')) {
      localStorage.removeItem('token')
      localStorage.removeItem('tokenExpiry')
      localStorage.removeItem('tokenRefreshExpiry')
      localStorage.removeItem('user')
      delete axios.defaults.headers.common['auth-token']
    }
    router.push('/login')
  }

  let ax = axios.create({
    baseURL: process.env.HATS_API,
    withCredentials: false,
    headers
  })
  ax.interceptors.request.use(function (config) {
    if (!canBeRefreshed) {
      clearToken()
    }
    return config
  })
  ax.interceptors.response.use(function (response) {
    return response
  }, function (error) {
    if (!!error && error.response.status === 405) {
      clearToken()
    }
  })
  return ax
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/index.js